<template>
  <div class="row" :class="[jel_getClassObject(content)]">
    <EditableArea
      v-if="mixinEnvironnement_inEditor"
      :content="content.salles"
      :parentTemplateId="metadata['mgnl:template']"
      class="w-100 h-100"
    />
    <div v-else class="overlay w-100">
      <div class="w-100 h-100">
        <Heritage :content="contentBanniereLaterale" />
      </div>
      <div v-if="indAfficherListeSalle" class="d-none d-lg-block">
        <div>
          <b-row :data-component-name="$options.name">
            <b-col
              md="6"
              offset-md="6"
              lg="5"
              offset-lg="7"
              xl="4"
              offset-xl="8"
              class="overlay_background col-xxl-3 offset-xxl-9 px-0"
            >
              <div class="d-flex justify-content-end mb-1">
                <button
                  class="fermerSalle ctn-shadow overlay_btn_taille_fixe btn d-flex align-items-center justify-content-center graphik_semibold py-1"
                  @click="indAfficherListeSalle = !indAfficherListeSalle"
                >
                  <div class="pr-1">{{ content.txtFermer }}</div>
                  <img
                    :src="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_closeLobby.svg`"
                    class="close_menu_icon"
                    alt="close-menu"
                  />
                </button>
              </div>
              <div class="overlay_content">
                <template v-for="aNode in content.salles['@nodes']">
                  <b-col
                    v-if="content.salles[aNode]['idSalle'] !== idSalleCourante"
                    :key="aNode"
                    class="px-4"
                  >
                    <BingoSalle class="py-1" :content="content.salles[aNode]"> </BingoSalle>
                  </b-col>
                </template>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div v-else class="changerSalle d-none d-lg-flex">
        <button
          class="btn btn_bingo_theme overlay_btn_taille_fixe btn_changer_salle graphik_semibold ctn-shadow"
          @click="indAfficherListeSalle = !indAfficherListeSalle"
        >
          <div>
            {{ content.txtChangerSalle }}
            <img
              v-lazy="
                `${mixinEnvironnement_damPath}/jel/bingo/clavardage/animateurs/ic_fleche_animateur_down.svg`
              "
              class="height_arrow"
              :alt="content.txtChangerSalle"
            />
          </div>
        </button>
      </div>
    </div>

    <div v-if="salles && !mixinEnvironnement_inMgnl">
      <iframe :src="iFrameURL" title="iFrame Bingo"></iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { EditableArea } from '@/vue-editor';
import BingoSalle from './BingoSalle.vue';
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';
import Heritage from '@/components/base/Heritage';

const URL_LANCEMENT = '/portal_api/sgbingo/launch';

export default {
  name: 'BingoJeu',
  components: {
    EditableArea,
    BingoSalle,
    Heritage,
  },
  mixins: [mixinEnvironnement],
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  data() {
    return {
      indAfficherListeSalle: false,
      contentBanniereLaterale: {
        lienInterne: process.env.VUE_APP_JEL_NOEUD_BINGO_BANNIERELATERALE,
      },
    };
  },
  computed: {
    ...mapGetters('bingo', ['getSalle', 'getSalleLive']),

    idSalleCourante() {
      return this.$route.query.idSalle;
    },
    salle() {
      return this.getSalle(this.idSalleCourante);
    },
    salles() {
      return this.getSalle(null);
    },
    iFrameURL() {
      const id = this.salle?.indSolo === 'true' ? 'game_id' : 'stream_id';
      const iFrame = `${URL_LANCEMENT}?${id}=${this.salle.idSalleNyx}`;
      return iFrame;
    },
  },
  created() {
    this.$store.dispatch('bingo/initSalles');
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
iframe {
  position: absolute;
  left: 0;
  border: none;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.overlay {
  z-index: 99;
  position: absolute;
  top: 0;
  right: 0;
  margin-right: 15px;
}

.overlay_content {
  height: 92vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.overlay_content::-webkit-scrollbar {
  width: 10px;
}

.overlay_content::-webkit-scrollbar-track {
  background-color: rgba(48, 48, 48, 0.6);
}

.overlay_content::-webkit-scrollbar-thumb {
  background-color: #aeaeae;
  border-radius: 10px;
  border-style: solid;
  border-color: #aeaeae;
}

.overlay_background {
  // background: #303030;
  background-color: rgba(48, 48, 48, 0.6);
  opacity: 1;
  height: 100vh;
}

.btn.fermerSalle,
.btn.fermerSalle:hover {
  border: none;
  background-color: rgba(15, 12, 12, 0.75) !important;
  color: white;
  text-align: right;
  border-radius: 40px;
}

.ctn-shadow {
  box-shadow: 1px 1px 13px 0px #a4a4a4;
}

.close_menu_icon {
  height: 1.25rem;
}

.changerSalle {
  color: black;
}

.btn_changer_salle {
  right: 0;
  position: absolute;
}

.overlay_btn_taille_fixe,
.overlay_btn_taille_fixe:hover {
  padding: 0.5rem 1rem;
  font-size: ms(-2);
  margin-top: 0.3rem;
  width: 12.5rem;
  height: 2.5rem;
  margin-right: 0.65rem;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  border: none;
  // opacity: 0.75 !important;
  opacity: unset !important;
}

.btn.btn_bingo_theme.btn_changer_salle,
.btn.btn_bingo_theme.btn_changer_salle:hover {
  color: black;
  background-color: rgba(239, 239, 239, 0.75) !important;

  .height_arrow {
    height: ms(-2);
  }
}
</style>
